<template>
  <div id="page-user-edit">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="基本情報">
            <div class="tab-text">
              <user-edit-tab-account
                class="mt-4"
                ref="userEditTabAccount"
                @closePopup="closePopupAction"
              />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import UserEditTabAccount from "./tabs/UserEditTabAccount.vue";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("enterpriseUserEdit");

export default {
  components: {
    UserEditTabAccount,
  },
  ...mapState({
    user: state => state.user,
  }),
  data() {
    return {
      userData: null,
      user_not_found: false,
      profile_photo: null,
      activeTab: 0
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),

    async closePopupAction() {
      this.$emit('closePopup');
    },
  },
  async created() {
    await this.fetchUser(this.$route.params.userId);
  },
};
</script>
